import axios from "axios";
import { toast } from "react-hot-toast";
import { signIn, signOut } from "next-auth/react";
import config from "@/config";

// use this to interact with our own API (/app/api folder) from the front-end side
// See https://shipfa.st/docs/tutorials/api-call
const apiClient = axios.create({
  baseURL: "/api",
});

apiClient.interceptors.response.use(
  function (response) {
    return response.data;
  },
  async function (error) {
    let message = "";

    if (error.response?.status === 401) {
      // Middleware will handle auth redirects
      toast.error("Please login");
      // Just reload to trigger middleware redirect
      window.location.reload();
    } else if (error.response?.status === 404 && error.config?.url === "/user/me") {
      // User account deleted but session still active
      toast.error("Account not found. Please sign in again.");
      await signOut({ redirect: false });
      window.location.href = "/";
      return Promise.reject(error);
    } else if (error.response?.status === 403) {
      // User not authorized, must subscribe/purchase/pick a plan
      message = "Pick a plan to use this feature";
    } else {
      message =
        error?.response?.data?.error || error.message || error.toString();
    }

    error.message =
      typeof message === "string" ? message : JSON.stringify(message);

    console.error(error.message);

    // Automatically display errors to the user
    if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("something went wrong...");
    }
    return Promise.reject(error);
  }
);

export default apiClient;
